import React from "react";

function TodoTitle() {
  return (
    <div>
      <h3 class="bgbox">Todo App:</h3>
    </div>
  );
}

export default TodoTitle;
